import { Button } from "@/components/ui/button";
import { ButtonStyleType } from "@/types";
import Link from "next/link";
import { useState, useEffect } from "react";
import parse from "html-react-parser";
import { cn } from "@/lib/utils";

export interface AnnouncementBarItem {
  title?: string;
  content?: string;
  hasButton?: boolean;
  dismissable?: boolean;
  buttonLink?: string;
  buttonText?: string;
  buttonStyle?: ButtonStyleType;
}
 interface AnnouncementBarProps {
  showAnnouncementBar?: boolean;
  announcementBar?: AnnouncementBarItem;
  className?: string;
  id?: string;
}

export const AnnouncementBar = ({ 
  showAnnouncementBar,
  announcementBar,
  className,
  id
}: AnnouncementBarProps) => {
  const [isVisible, setIsVisible] = useState(showAnnouncementBar);

  // Update visibility when prop changes (for live preview)
  useEffect(() => {
    setIsVisible(showAnnouncementBar);
  }, [showAnnouncementBar]);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div id={id} className={cn(
      "w-full bg-brand",
      className
    )}>
      <div className={cn("relative flex flex-col gap-6 px-4 lg:px-8 py-2 md:flex-row md:items-center md:justify-between", !announcementBar?.hasButton && "!justify-center")}>
        {announcementBar?.dismissable && (
          <Button
            variant="ghost"
            size="iconSm"
            className="absolute top-4 right-4 h-8 w-8 md:hidden text-white"
            onClick={handleClose}
          >
            <span className="material-symbols-outlined">close</span>
          </Button>
        )}
        <div className={cn("flex flex-col items-start gap-2 pr-10 md:pr-0 md:flex-row md:items-center", !announcementBar?.hasButton && "!pr-0")}>
          {announcementBar?.title && (
            <div className="paragraph-base font-bold text-white whitespace-nowrap">{announcementBar?.title}</div>
          )}
          {announcementBar?.content && (
            <div className="paragraph-base text-white">{parse(announcementBar?.content ?? "")}</div>
          )}
        </div>

        {(announcementBar?.hasButton || announcementBar?.dismissable) && (
          <div className="flex items-center gap-2">
            {announcementBar?.hasButton && (
              <Button
                variant={announcementBar?.buttonStyle}
                size="sm"
                className="w-full md:w-auto border-white text-white"
                asChild
              >
                <Link href={announcementBar?.buttonLink ?? "/"}>
                  {announcementBar?.buttonText}
                </Link>
              </Button>
            )}
            {announcementBar?.dismissable && (
              <Button
                variant="ghost"
                size="iconSm"
                className="hidden h-8 w-8 md:inline-flex text-white"
                onClick={handleClose}
              >
                <span className="material-symbols-outlined">close</span>
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

AnnouncementBar.displayName = 'AnnouncementBar'; 